/**
 * Column widths shared by UsersTable and its skeleton, so the loading state never shifts the
 * layout. Teams has none: as in the design, it takes the room the fixed columns leave.
 */
export const USERS_COLUMN_WIDTHS = {
  user: 180,
  email: 200,
  activation: 150,
  role: 160,
  access: 170,
  status: 100,
  actions: 48,
} as const;

/** The design's table width: below it the table scrolls sideways instead of squeezing cells. */
export const USERS_TABLE_SCROLL_X = 1100;
